import { useState } from "react";
import { resolveAssetPath } from "@/lib/assets";
import { FALLBACK_IMAGES } from "@/data/tours";

/**
 * Image with a guaranteed local fallback if a remote (Unsplash) URL fails.
 * Keeps the UI free of broken-image states.
 */
export const SmartImage = ({
  src,
  alt = "",
  className = "",
  fallbackIndex = 0,
  useLocalFallback = false,
  priority = false,
  ...rest
}) => {
  const [failed, setFailed] = useState(false);
  const finalSrc = failed || useLocalFallback
    ? resolveAssetPath(FALLBACK_IMAGES[fallbackIndex % FALLBACK_IMAGES.length])
    : resolveAssetPath(src);
  return (
    <img
      src={finalSrc}
      alt={alt}
      loading={priority ? "eager" : "lazy"}
      decoding="async"
      onError={() => setFailed(true)}
      className={className}
      {...rest}
    />
  );
};
